import {tablesTableData} from "../../../variables/general";
import {Flex} from "@chakra-ui/react";
import School from "./User";
import User from "./User";

function UserSetup() {
    return (
        <Flex direction='column' pt={{base: "120px", md: "75px"}}>
            <User
                title={"User Table"}
                captions={["User Detail","School Name", "Wrong Password Attempt","Role", "Status", ""]}
            />
        </Flex>
    );
}

export default UserSetup;